module.exports = __webpack_public_path__ + "static/media/technology-icon-facilitate.0d1b2225.png";